import { getGridStringOperators } from "@mui/x-data-grid-pro";

const stringOperatorsToEliminate = ["doesNotContain", "doesNotEqual"];

const filteringStringOperators = (operators) =>
    operators.filter(({ value }) => !stringOperatorsToEliminate.includes(value));

const useColumns = (rawColumns) => {
    /**
     * In MuiDatagrid v7 there are two new string filter operators: doesNotContain, doesNotEqual
     * There is server side filtering on backend side, as temporary solution, they are needed to be 
     * eliminated from the operator list, until they are not implemented on backend side too.
     * 
     * Consider the SearchTemplates too, it stores filter model and the isNot custom filter 
     * operator won't be necessary anymore, but it can be used in search templates.
     */
    const columns = rawColumns.map((column) => {
        if (column.type && column.type !== "string") {
            return column;
        }

        return {
            ...column,
            filterOperators: filteringStringOperators(
                column.filterOperators || getGridStringOperators(),
            ),
        };
    });

    return { columns };
};

export default useColumns;
